/* eslint-disable no-param-reassign */
/**
 * Created by zad on 17/10/18.
 */
import Immutable from 'immutable';
import { NoteHistory } from '../../constants/actionTypes';

const initialState = {
  list: [],
  status: NoteHistory.NOTE_HISTORY_INIT,
  contents: {
    status: NoteHistory.NOTE_HISTORY_CONTENT_INIT,
    entities: {},
  },
  restore: {
    status: NoteHistory.NOTE_HISTORY_RESTORE_INIT,
  },
};

export default function (state = Immutable.fromJS(initialState), action) {
  switch (action.type) {
    // 重置NoteHistory
    case NoteHistory.NOTE_HISTORY_INIT: {
      // 清空list
      state = state.setIn(['status'], NoteHistory.NOTE_HISTORY_INIT);
      state = state.setIn(['list'], Immutable.fromJS([]));
      // 清空contens
      state = state.setIn(['contents', 'status'], NoteHistory.NOTE_HISTORY_CONTENT_INIT);
      state = state.setIn(['contents', 'entities'], Immutable.fromJS({}));
      // reset restore
      state = state.setIn(['restore', 'status'], NoteHistory.NOTE_HISTORY_RESTORE_INIT);

      return state;
    }
    // 获取history list
    case NoteHistory.GET_NOTE_HISTORY_LIST: {
      const { noteId } = action;
      state = state.setIn(['status'], NoteHistory.GET_NOTE_HISTORY_LIST);
      return state;
    }
    case NoteHistory.GET_NOTE_HISTORY_LIST_SUCCESS: {
      const { data } = action;
      window.itemdatas = data;
      // 存储之前先按修改时间排下顺序
      state = state.setIn(['list'], Immutable.fromJS(data.sort((a, b) => (b.updated_at - a.updated_at))));
      state = state.setIn(['status'], NoteHistory.GET_NOTE_HISTORY_LIST_SUCCESS);
      return state;
    }
    case NoteHistory.GET_NOTE_HISTORY_LIST_FAIL: {
      state = state.setIn(['status'], NoteHistory.GET_NOTE_HISTORY_LIST_FAIL);
      return state;
    }
    // 获取history content
    case NoteHistory.GET_NOTE_HISTORY_CONTENT: {
      const { noteId } = action;
      state = state.setIn(['contents', 'status'], NoteHistory.GET_NOTE_HISTORY_CONTENT);
      return state;
    }
    case NoteHistory.GET_NOTE_HISTORY_CONTENT_SUCCESS: {
      const { data, historyId } = action;
      state = state.setIn(['contents', 'entities', historyId.toString()], Immutable.fromJS(data));
      state = state.setIn(['contents', 'status'], NoteHistory.GET_NOTE_HISTORY_CONTENT_SUCCESS);
      return state;
    }
    case NoteHistory.GET_NOTE_HISTORY_CONTENT_FAIL: {
      state = state.setIn(['contents', 'status'], NoteHistory.GET_NOTE_HISTORY_CONTENT_FAIL);
      return state;
    }
    // 恢复history content
    case NoteHistory.RESTORE_NOTE_HISTORY_CONTENT: {
      state = state.setIn(['restore', 'status'], NoteHistory.RESTORE_NOTE_HISTORY_CONTENT);
      return state;
    }
    case NoteHistory.RESTORE_NOTE_HISTORY_CONTENT_SUCCESS: {
      state = state.setIn(['restore', 'status'], NoteHistory.RESTORE_NOTE_HISTORY_CONTENT_SUCCESS);
      return state;
    }
    case NoteHistory.RESTORE_NOTE_HISTORY_CONTENT_FAIL: {
      state = state.setIn(['restore', 'status'], NoteHistory.RESTORE_NOTE_HISTORY_CONTENT_FAIL);
      return state;
    }
    default:
      return state;
  }
}

export const getNoteHistoryState = state => state.NoteHistory;

export const getNoteHistoryContentsState = state => state.NoteHistory.get('contents');



// WEBPACK FOOTER //
// ./src/reducers/NoteHistory/NoteHistoryReducer.js